import { Column } from 'react-table'

export enum TableListStaticColumnsEnum {
  DETAILS = 'DETAILS',
  ICON = 'ICON',
}

export type TableListProps<
  T extends {
    url?: string
  },
> = {
  columns: Column<T>[]
  data: T[]
  e2eRowId: string
  isLoading?: boolean
  isSearching?: boolean
  selectedRowIndex?: number | null
  className?: string
  hideArrow?: boolean
}
